module.exports = __webpack_public_path__ + "img/button.7572d599.png";